import { render, staticRenderFns } from "./suborgDetails.vue?vue&type=template&id=7fd30e3d&scoped=true"
import script from "./suborgDetails.vue?vue&type=script&lang=js"
export * from "./suborgDetails.vue?vue&type=script&lang=js"
import style0 from "./suborgDetails.vue?vue&type=style&index=0&id=7fd30e3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd30e3d",
  null
  
)

export default component.exports